import { useState } from 'react';
import { ProductAggregateDocument, ProductVariantDocument } from '@/types/manage.types';
import IngredientsCollapsible from './fragments/ingredients-collapsible';
import { ProductImage } from './ProductImage';
import { ProductInfo } from './ProductInfo';
import { VariantSelector } from './VariantSelector';
import { AddToCartSection } from './AddToCartSection';
import { ComponentErrorBoundary } from '@/components/error/ComponentErrorBoundary';

interface ProductCardProps {
  product: ProductAggregateDocument;
  extended?: boolean;
}

export function ProductCard({ product, extended }: ProductCardProps) {
  const [selectedVariant, setSelectedVariant] = useState<ProductVariantDocument | null>(null);

  return (
    <div
      className={`bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform md:hover:-translate-y-2 overflow-hidden w-full ${
        extended ? 'h-full rounded-none' : ''
      }`}>
      <ComponentErrorBoundary componentName="Product Image">
        <ProductImage src={product.images[0]} alt={product.name} productName={product.name} />
      </ComponentErrorBoundary>

      <div className="p-6">
        <ComponentErrorBoundary componentName="Product Info">
          <ProductInfo product={product} />
        </ComponentErrorBoundary>

        {/* Ingredients Toggle */}
        <div className="mb-4">
          <ComponentErrorBoundary componentName="Ingredients">
            <IngredientsCollapsible product={product} />
          </ComponentErrorBoundary>
        </div>

        {/* Variant Selection */}
        <ComponentErrorBoundary componentName="Variant Selector">
          <VariantSelector product={product} onVariantChange={setSelectedVariant} />
        </ComponentErrorBoundary>

        {/* Add to Cart Section */}
        <ComponentErrorBoundary componentName="Add to Cart">
          <AddToCartSection product={product} selectedVariant={selectedVariant} />
        </ComponentErrorBoundary>
      </div>
    </div>
  );
}
